import React from 'react';

const PlusIcon = props => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : '24'}
         height={props.height ? props.height : '24'} viewBox="0 0 24 24" fill="none"
         stroke={props.stroke ? props.stroke : 'currentColor'}
         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
    >
        <path d="M5 12h14"/>
        <path d="M12 5v14"/>
    </svg>
);

export default PlusIcon;



// WEBPACK FOOTER //
// ./src/assets/icons/PlusIcon.jsx